<div class="detail-parent-card gap-3">
  <span class="detail-card-title" i18n>Age for Minimum Calculation</span>
  <div class="card-grid">
    <app-vb-payment-change-age-for-minimum-calculation-jurisdiction
      *ngFor="let account of accountDetails; trackBy: trackByIndex"
      [account]="account" />
  </div>
</div>
